import { Inject, Injectable } from '@angular/core';
import {mbeConfigService} from './mbe-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BfeeSourceAPI, BfeeSourceInterface } from '../..';
import {
  normalizeBfeeSourceForCreateApi,
  normalizeBfeeSourceForUpdateApi,
} from '../util/bfee-source-request-payload.util';

@Injectable({
  providedIn: 'root',
})
export class BfeeSourceService {
  // Use pre-defined environment

  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  // tslint:disable-next-line:max-line-length
  getAllBfee(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sourceNo: number,
    gid: number,
    rno: number
  ): Observable<BfeeSourceAPI> {
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<BfeeSourceAPI>(
      `${this.URL}/bfs/allbfee/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}/${sourceNo ? sourceNo : 0}/${gid ? gid : 0}/${
        rno ? rno : 0
      }`,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  getBfee(id: number): Observable<BfeeSourceInterface> {
    const headers = this.headers;
    return this.httpClient.get<BfeeSourceInterface>(
      `${this.URL}/bfs/singlebfee/${id}`,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  CreateBfee(source: BfeeSourceInterface): Observable<BfeeSourceInterface> {
    const headers = this.headers;
    // Strip souGid/souRno — only BFeeSourceReq fields allowed on create. 15/09/2026 PK.
    // const body = source;
    const body = normalizeBfeeSourceForCreateApi(source as unknown as Record<string, unknown>);
    return this.httpClient.post<BfeeSourceInterface>(
      `${this.URL}/bfs/createbfee`,
      body,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  UpdateBfee(source: BfeeSourceInterface): Observable<BfeeSourceInterface> {
    const headers = this.headers;
    // Strip souGid/souRno from update body for consistency. 15/09/2026 PK.
    // const body = source;
    const body = normalizeBfeeSourceForUpdateApi(source as unknown as Record<string, unknown>);
    return this.httpClient.post<BfeeSourceInterface>(
      `${this.URL}/bfs/updatebfee`,
      body,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }
}


